export default __webpack_public_path__ + "static/media/Leaf2-reverse.d2dc0573.png";